define("calendar/models/ig-comment", ["exports", "@ember/object", "@ember/object/computed", "@ember/template"], function (_exports, _object, _computed, _template) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"@ember/object",0,"@ember/object/computed",0,"@ember/template"eaimeta@70e063a35619d71f

  var _default = _object.default.extend({
    createdTime: null,
    id: null,
    hidden: false,
    likeCount: 0,
    mediaId: null,
    nextRepliesUrl: null,
    parentId: null,
    replies: null,
    socialProfile: null,
    text: null,
    user: null,
    userId: null,
    username: null,
    userProfilePicture: null,
    userfullName: null,
    createdMoment: (0, _object.computed)('createdTime', function () {
      return moment(this.createdTime * 1000);
    }),
    formattedTime: (0, _object.computed)('createdTime', function () {
      const time = this.createdTime; // Posted today

      if (moment(time * 1000).isSame(moment(), 'day')) {
        return moment(time * 1000).format('h:mm A');
      }

      return moment(time * 1000).format('DD MMM');
    }),
    hasMoreReplies: (0, _computed.notEmpty)('nextRepliesUrl'),
    isReply: (0, _computed.notEmpty)('parentId'),
    textFormatted: (0, _object.computed)('textWithLinebreaks', function () {
      let formattedText = this.get('textWithLinebreaks.string') || '';
      formattedText = (0, _template.htmlSafe)(formattedText);
      return formattedText;
    }),
    textFormattedTruncateShort: (0, _object.computed)('textWithLinebreaks', function () {
      let truncatedText = this.get('textWithLinebreaks.string') || '';
      const lines = truncatedText.split('<br>');
      const numLines = lines.length;

      if (numLines > 3) {
        truncatedText = lines.slice(0, 3).join('<br>') + '...';
      } else if (truncatedText.length > 20) {
        truncatedText = truncatedText.substring(0, 80) + '...';
      }

      return (0, _template.htmlSafe)(truncatedText);
    }),
    textFormattedTruncateMedium: (0, _object.computed)('textWithLinebreaks', function () {
      let truncatedText = this.get('textWithLinebreaks.string') || '';
      const lines = truncatedText.split('<br>');
      const numLines = lines.length;

      if (numLines > 5) {
        truncatedText = lines.slice(0, 5).join('<br>') + '...';
      } else if (truncatedText.length > 200) {
        truncatedText = truncatedText.substring(0, 200) + '...';
      }

      return (0, _template.htmlSafe)(truncatedText);
    }),
    textTruncated: (0, _object.computed)('text', function () {
      return this.text.length > 100 ? this.text.substring(0, 100) + '...' : this.text;
    }),
    textWithLinebreaks: (0, _object.computed)('text', function () {
      let formattedText = this.text || '';

      if (!formattedText) {
        return '';
      }

      formattedText = formattedText.replace(/(\r\n|\n|\r)/gm, '<br>');
      formattedText = (0, _template.htmlSafe)(formattedText);
      return formattedText;
    })
  });

  _exports.default = _default;
});